/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment} from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, TextField, Snackbar, Tabs, Tab, CircularProgress, Button, Fab } from '@material-ui/core'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'
import Autocomplete from '@material-ui/lab/Autocomplete';

import Actions from '../../../fluid/Actions/ActionFactory'
import Result from '../../Results/Result'

import logo from '../../../assets/sainapse_logo2.png'

import { allowedByOpop } from '../../Security/SecureCheck'

import LinkedScreen from '../../LinkedScreens/LinkedScreen'
import CTAButton from '../../Results/components/CTAButton';

let equal = require('deep-equal')

const styles = theme => ({
    open : {
        width : '100vw',
        height : 'calc(100vh - 48px)',
        display: 'flex',
        flexDirection : 'column',
        justifyContent : 'center',
        alignItems : 'center'
    },
    search : {
        boxSizing : 'border-box',
        height : '100%',
        display: 'flex',
        flexDirection : 'column',
    },
    search_open : {
        width : '75vw',
    },
    search_full : {
        boxSizing : 'border-box',
        width : '100%',
        margin: '10px'
    }
})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

class CognitiveSearch extends Component {
    state = {
        open : true,
        show_search_bar : true,
        loading_ic : false,
        ic_list : [],
        external_sources : [],
        drl_url : "",
        selected_ic : [],
        ic_list_pushed : [],
        search_type : null,
        search_string : "",
        search_fields : {},
        searching: false,
        search_reco_error : false,
        results : [],
        class_results : [],
        results_received : false,
        class_received : false,
        class_error : false,
        show_results : false,
        snackbar_open : false,
        timestamp : null,
        copy_to_parent : false,
        window_width : null,
        window_height : null,
        collapse : true,
        result_container_height : 0,
        params_loaded :false,
        results_tab : 0
    }

    searchBar = React.createRef()
    screenHeight = React.createRef()

    componentWillMount () {
        this.setState({...this.state, loading_ic : true}, () => {
            Actions('http_request', {
                url : '/sainapse/information_channel',
                method : 'get',
                data : {}
            }).then(res => {
                let recommend_ic_list = []
                let ic_list = res.data.result;
                // res.data.result.map(ic => {
                //     if (ic.training_status === 'Completed') {
                //         ic_list.push(ic.name)
                //     }
                //     //ic_list.push(ic.name)
                // })
    
                for (let i = 0 ; i < ic_list.length; i++) {
                    if (ic_list[i].operations.includes("Recommend") || ic_list[i].operations.includes("Classify") ) {
                        let ic = {
                            name : ic_list[i].name,
                            trained : false
                        }

                        let recommendation_training_status = ic_list[i].training_status_object.filter((el) => ( el.operation === 'Recommend'))
                        let classification_training_status = ic_list[i].training_status_object.filter((el) => ( el.operation === 'Classify'))


                        let last_rec_status = recommendation_training_status.length > 0 ? recommendation_training_status.sort((a,b) => new Date(b.request_time) - new Date(a.request_time))[0].status : null
                        let last_class_status = classification_training_status.length > 0 ? classification_training_status.sort((a,b) => new Date(b.request_time) - new Date(a.request_time))[0].status : null

                        if (last_rec_status === 'Completed' || last_class_status === 'Completed') {
                            ic.trained = true
                        }

                        // if (ic_list[i].training_status_object.findIndex((el) => ( el.operation === 'Recommend' || el.operation === 'Classify' ) && el.status === 'Completed') !== -1) {
                        //     ic.trained = true
                        // }
    
                        recommend_ic_list.push(ic)
                    }
                }
               
                this.setState({...this.state, ic_list : recommend_ic_list, loading_ic : false}, () => this.setParams())
            })
        })

        Actions('http_request', {
            url : "/sainapse/data_rendering_service",
            method : 'get',
            data : {}
        }).then(res => {
            console.log('DRL Result: ', res.data)
            this.setState({...this.state, drl_url : res.data.result[0].url})
        }).catch(err => {

        })
    }

    componentDidMount () {
        window.addEventListener('resize', this.resizeWindow)
    }

    resizeWindow = () => {
        var toPX = require("to-px");
        this.setState({...this.state,
            window_height : this.screenHeight.current.clientHeight,
            window_width : toPX("100vw")
        })
    }

    componentDidUpdate (prevProps) {
        if (!equal(prevProps.params, this.props.params)) {
            this.setParams()
        }
    }

    resizeWindow = () => {
        var toPX = require("to-px");
        this.setState({...this.state,
            window_height : this.screenHeight.current.clientHeight,
            window_width : toPX("100vw")
        })
    }

    setParams = () => {
        let params = {
            selected_ic : [],
            ic_list_pushed : [],
            open : true,
            search_type : null,
            search_string : "",
            search_fields : {},
            copy_to_parent : false,
            filters : [],
            external_sources : [],
            cta_config : []
        }

        let query_params = this.loadQueryParams()
        console.log("Query Params : ", query_params)
        let default_params = this.loadDefaultParams()
        console.log("Default Params : ", default_params)

        if (default_params.search_type) {
            if (default_params.search_type === 'multifield') {
                params.search_type = 'multifield'
                let search_fields = default_params.search_fields.map(field => field.name)
                search_fields.map(field => {
                    params.search_fields[field] = query_params[field] !== null && query_params[field] !== undefined ? query_params[field] : ""
                })
            } else {
                params.search_type = 'freetext'
                params.search_string = query_params.searchString !== null && query_params.searchString !== undefined ? query_params.searchString : ""
            }
        } else {
            params.search_type = 'freetext'
            params.search_string = query_params.searchString !== null && query_params.searchString !== undefined ? query_params.searchString : ""
        }

        params.selected_ic = query_params.icName !== null && query_params.icName !== undefined ? query_params.icName : []
        params.open = query_params.showSearchbar !== null && query_params.showSearchbar !== undefined ? JSON.parse(query_params.showSearchbar) : true
        params.copy_to_parent = query_params.copyToParent !== null && query_params.copyToParent !== undefined ? JSON.parse(query_params.copyToParent) : false

        if (query_params.icName !== null && query_params.icName !== undefined) {
            let ic_list_pushed = query_params.icName.map(ic => ic.name)
            params.ic_list_pushed = ic_list_pushed
        }

        console.log("Params after QueryParams : ", params)

        params.selected_ic = default_params.icList !== null && default_params.icList !== undefined ? default_params.icList : params.selected_ic
        params.open = default_params.showSearchbar !== null && default_params.showSearchbar !== undefined ? JSON.parse(default_params.showSearchbar) : params.open
        params.search_string = default_params.searchString !== null && default_params.searchString !== undefined ? default_params.searchString : params.search_string
        params.copy_to_parent = default_params.copyToParent !== null && default_params.copyToParent !== undefined ? JSON.parse(default_params.copyToParent) : params.copy_to_parent
        params.filters = default_params.filters

        if (default_params.icList !== null && default_params.icList !== undefined) {
            let ic_list_pushed = default_params.icList.map(ic => ic.name)
            params.ic_list_pushed = ic_list_pushed
        }

        params.external_sources = default_params.external_sources ? default_params.external_sources !== null ? default_params.external_sources : [] : []
        params.cta_config = default_params.cta_config ? default_params.cta_config !== null ? default_params.cta_config : [] : []
        params.screen_cta_config = default_params.screen_cta_config ? default_params.screen_cta_config !== null ? default_params.screen_cta_config : null : null
        console.log("Params after DefaultParams : ", params)

        let selected_ic_obj = []
        
        params.selected_ic.forEach(ic => {
            let ic_obj = this.state.ic_list.find(_ic => _ic.name === ic)
                if (ic_obj !== undefined) {
                    if (ic_obj.trained) {
                        selected_ic_obj.push(ic_obj)
                    }
                }
        })

        params.selected_ic = selected_ic_obj

        console.log("Final Params : ", params)

        this.setState({
            ...this.state,
            ...params,
            params_loaded : true
        }, () => {
            if (this.state.selected_ic.length > 0) {
                if (this.state.search_type === 'freetext' && this.state.search_string !== "") {
                    this.triggerSearch()
                }
                if (this.state.search_type === 'multifield') {
                    let field_values = Object.values(this.state.search_fields)
                    let field_keys = Object.keys(this.state.search_fields)
                    if (field_values.filter(val => val === "").length < field_keys.length) {
                        this.triggerSearch()
                    }
                }
            }
        })
    }

    loadDefaultParams = () => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
        let op_section = routes.find(section => section.id === 'operations')
        let search_section = op_section.screens.find(section => section.id === 'search')
        let screen = search_section.screens.find(route => route.route === this.props.location.pathname)
        let params = screen.default_params
        console.log("Default Params in Config : ", params)
        let params_with_values = params !== null ? Object.entries(params).filter(entry => entry[1] !== null) : []
        return Object.fromEntries(params_with_values) 
    }

    loadQueryParams = () => {
        let params = this.props.params
        console.log("params :", this.props.params)
        let params_with_values = Object.entries(params).filter(entry => entry[1] !== null)
        console.log("params_with_values:", params_with_values)
        return Object.fromEntries(params_with_values) 
    }

    handleParams = () => {
        console.log("IC List : ", this.state.ic_list)
        console.log("Query Params in Search : ", this.props.params)
        let params_list = Object.keys(this.props.params)
        console.log("Params List : ", params_list)

        let query_params = this.loadQueryParams()
        console.log("Query Params : ", query_params)
        let default_params = this.loadDefaultParams()
        console.log("Default Params : ", default_params)

        if (params_list.length > 0) {
            if (params_list.includes('icName') && params_list.includes('searchString')) {
                let icNameParams = [...this.props.params.icName]
                console.log('Query Params IC List : ', icNameParams)
                console.log('Query Params Search String : ', this.props.params.searchString)
                let show_search_bar = this.props.params.showSearchbar !== undefined ? JSON.parse(this.props.params.showSearchbar) : true
                let copy_to_parent = this.props.params.copyToParent !== undefined ? JSON.parse(this.props.params.copyToParent) : false
                let selected_ic_list = []

                icNameParams.forEach(ic => {
                    let ic_obj = this.state.ic_list.find(_ic => _ic.name === ic)
                    if (ic_obj !== undefined) {
                        if (ic_obj.trained) {
                            selected_ic_list.push(ic_obj)
                        }
                    }
                })
                
                if (selected_ic_list.length > 0) {
                    this.setState({
                        ...this.state, 
                        selected_ic : selected_ic_list, 
                        search_string : this.props.params.searchString, 
                        show_search_bar : show_search_bar,
                        copy_to_parent : copy_to_parent
                    }, () => this.triggerSearch())
                }
            }
        }
    }


    getSearchString = () => {
        return this.state.search_string
    }

    copyText = (text) => {
        if (this.state.copy_to_parent) {
            window.parent.postMessage({ message : "Sainapse: Copy Content", value : text}, "*")
        } else {
            navigator.clipboard.writeText(text)
        }
    }

    getICList = () => {
        let ic_list = this.state.selected_ic.map(ic => ic.name)
        return ic_list
    }

    renderResultsTabs = () => {
        // var toPX = require("to-px");
        // let cur_height = toPX('100vh')
        // let container_height = cur_height - 60
        return (
            <Paper square variant = 'outlined' style = {{width : '100%', padding : 0, margin: 0, borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                <Tabs
                    value={this.state.results_tab}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={(event, newValue) => this.setState({...this.state, results_tab : newValue})}
                    aria-label="disabled tabs example"
                >
                    <Tab label="Sainapse Results"/>
                    {this.state.external_sources.map(src => {
                        return (
                            <Tab label = {src.link_name}/>
                        )
                    })}
                </Tabs>
            </Paper>
        )
    }

    getLinkConfig = (results_tab) => {
        if (results_tab !== 0) {
            let external_source = this.state.external_sources[results_tab - 1]
            let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
            let links_section = routes.find(section => section.id === 'links')
            let link_config = links_section.screens.find(screen => screen.id === external_source.link_id)
            if (link_config) {
                return link_config
            } else {
                return null
            }
        }
    }

    getLinkQueryParams = (results_tab) => {
        let external_source = this.state.external_sources[results_tab - 1]
        let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
        let links_section = routes.find(section => section.id === 'links')
        let link_config = links_section.screens.find(screen => screen.id === external_source.link_id)

        let link_query_params = link_config.default_params.query_params
        let query_params = link_query_params.map(qp => {
            let query_map = external_source.query_map.find(qm => qm.key_name === qp.key)
            let value_list = query_map.value_map.map(field => {
                if (field === 'searchtext') {
                    return this.state.search_string
                } else {
                    return this.state.search_fields[field]
                }
            })
            return {
                key : qp.key,
                default_value : value_list.join(" ")
            }
        })

        return query_params
    }


    renderResultsTabContainers = () => {
        var toPX = require("to-px");
        let cur_height = toPX('100vh')
        let container_height = cur_height - 120
        if (this.state.results_tab === 0) {
            return this.renderSainapseResults()
        } else {
            return (
                <LinkedScreen
                    key = {this.state.results_tab}
                    embedded = {true}
                    config = {this.getLinkConfig(this.state.results_tab) !== null ? this.getLinkConfig(this.state.results_tab) : {}}
                    width = {this.state.open ? toPX("75vw") : toPX('100vw')}
                    height = {container_height}
                    query_params = {this.getLinkQueryParams(this.state.results_tab)}
                />
            )
        }
    }

    renderSainapseResults = () => {
        var toPX = require("to-px");
        let cur_height = toPX('100vh')
        let container_height = cur_height - 120
        if (this.state.results_received && this.state.class_received) {
            console.log("Reco Results going in :", this.state.results)
            console.log("Class Results going in :", this.state.class_results)
            console.log("Rendering Results with width : ", toPX("75vw"))
            return (
                <Fragment>
                    <Result
                        key = {this.state.timestamp}
                        height = {container_height}
                        ic_list = {this.state.ic_list_pushed}
                        width = {this.state.open ? toPX("75vw") : toPX('100vw')}
                        results = {this.state.results}
                        reco_label = "Recommendations"
                        class_results = {this.state.class_results}
                        class_label = "Classification"
                        drl_url = {this.state.drl_url}
                        searching = {this.state.searching}
                        search_string = {this.getSearchString}
                        key_terms = {[]}
                        copy = {(text) => this.copyText(text)}
                        re_attach = {false}
                        attach_options = {[]}
                        cta_config = {this.state.cta_config}
                        execute_cta = {(cta_config, record) => this.executeCTA(cta_config, record)}
                    />
                    <Snackbar
                        anchorOrigin={{ vertical : "top", horizontal : "center" }}
                        open={this.state.snackbar_open}
                        onClose={this.handleClose}
                        message="Text Copied"
                        autoHideDuration = {1000}
                    />
                </Fragment>
            )
        } else if (this.state.search_reco_error === true && this.state.class_error === true) {
            return (
                <div style = {{width : '100%', height : container_height, display: 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <Typography variant = 'caption' color = 'secondary'>Error retreiving search results</Typography>
                </div>
            )
        }
    }

    handleClose = () => {
        this.setState({ ...this.state, snackbar_open: false });
    }

    executeCTA = (cta_config, record) => {
        //console.log("CTA Executed for record : ", record)
        console.log("CTA Executed for config : ", cta_config)

        let field_maps = cta_config.fields
        let key_values = []
        field_maps.forEach(fmap => {
            let entry = []
            entry[0] = fmap.field_name

            let value_source = fmap.source.split('.')[0]
            let value_type = fmap.source.split('.')[1]

            if (value_source === 'native') {
                if (value_type === 'raw_field') {
                    entry[1] = record.raw_fields.fields.find(field => field.name === fmap.mapped_to).value
                } else if (value_type === 'world_view') {
                    entry[1] = record.wv_field_list.find(field => field.name === fmap.mapped_to).value.text
                }
            } else if (value_source === 'custom') {
                if (value_type === 'static') {
                  entry[1] = fmap.mapped_to
                }
            }

            key_values.push(entry)
        })

        // let fields = Object.fromEntries(key_values)

        if (cta_config.post_to_parent) {
            let payload = Object.fromEntries(key_values)
            window.parent.postMessage({ message : "Sainapse: CTA", value : JSON.stringify(payload)}, "*")
        } else {
            let query_params = key_values.map(key_value => key_value[0] + "=" + encodeURIComponent(key_value[1]))
            let query_string = query_params.join('&')
            let trigger_url = cta_config.trigger_url + "?" + query_string
            if (cta_config.open_in_new_window) {
                console.log("new window", cta_config.open_in_new_tab)
                window.open(trigger_url, "cta-window", "width=1000,height=800")
            }
            else {
                window.open(trigger_url)
            }           
        }
    }

    renderResults = () => {
        var toPX = require('to-px')
        // if (this.state.open) {
        //     <div style = {{width : '73vw', height : 'calc(100vh - 50px)', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent: 'center'}}>
        //         <Typography variant = 'body2' color = 'textSecondary'>Fill in the required fields to get recommendation...</Typography>
        //     </div>
        // } else if (this.state.searching) {
        //     this.renderProgress()
        // }
        console.log(this.state.results_received)
        if (this.state.results_received && this.state.class_received) {
            // console.log("Screen Height :", this.screenHeight.current.clientHeight)
            // let result_container_height = this.screenHeight.current.clientHeight - this.searchBar.current.clientHeight
            //let result_container_height = screen_height - this.searchBar.current.clientHeight + 50

            // return this.renderSainapseResults()
            return (
                <div>
                    {this.renderResultsTabs()}
                    {this.renderResultsTabContainers()}
                </div>
            )

        }
    }

    getHelperText= () => {
        var accessObject = {
            operation : "/sainapse/recommendation/freetext",
            method : "POST",
            operands : []
        }
        return !allowedByOpop(accessObject) ? 'User does not have sufficient privileges' : ''
    }

    renderICSelect = () => {
        return(
            <Autocomplete
                style = {{margin : '10px'}}
                multiple
                id="tags-standard"
                options={this.state.ic_list}
                getOptionLabel={(option) => option.name}
                getOptionDisabled = {(option) => option.trained === false}
                value = {this.state.selected_ic}
                loading = {this.state.loading_ic}
                disabled = {!allowedByOpop({
                    operation : "/sainapse/recommendation/freetext",
                    method : "POST",
                    operands : []
                    }) || this.state.search_type === 'multifield'}
                onChange = {(event, newValue) => this.setState({...this.state, selected_ic : newValue}, () => console.log("Selected IC :", newValue))}
                renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    size = 'small'
                    label="Select Information Channels"
                    helperText= {this.getHelperText()}
                />
                )}
                ChipProps = {{
                    color : 'primary',
                    size : 'small'
                }}
                renderOption={(option, { selected }) => (
                    <React.Fragment>
                        <div style = {{width: '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', borderBottom : '1px solif rgba(0,0,0,0.12)'}}>
                            <Typography style = {{flexGrow : 1}}>{option.name}</Typography>
                            {option.trained === false ? <Typography variant = 'caption'>Not Trained</Typography> : null}
                        </div>
                    </React.Fragment>
                )}
            />
        )
    }

    handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault()
            this.triggerSearch()
        }
    }

    renderSearchField = () => {
        if (this.state.search_type === 'freetext') {
            return (
                <div
                    style = {{
                        padding : '10px',
                        width : '100%'
                    }}
                >
                    <TextField
                        style = {{
                            width : '100%'
                        }}
                        variant = 'outlined'
                        label = "Ask Sainapse"
                        multiline
                        minRows={5}
                        value = {this.state.search_string}
                        onChange = {(event) => this.setState({...this.state, search_string: event.target.value})}
                        // onKeyDown = {(e) => this.handleKeyDown(e)}
                    />
                </div>
            )
        } else if (this.state.search_type === 'multifield') {
            let fields = Object.keys(this.state.search_fields)
            return (
                <Fragment>
                    {fields.map(field => {
                        return (
                            <div
                                style = {{
                                    padding : '10px',
                                    width : '100%'
                                }}
                            >
                                <TextField
                                    style = {{
                                        width : '100%'
                                    }}
                                    variant = 'outlined'
                                    label = {field}
                                    multiline
                                    minRows={3}
                                    value = {this.state.search_fields[field]}
                                    onChange = {(event) => {
                                        let search_fields_state = {...this.state.search_fields}
                                        search_fields_state[field] = event.target.value
                                        this.setState({...this.state, search_fields : search_fields_state})
                                    }}
                                    // onKeyDown = {(e) => this.handleKeyDown(e)}
                                />
                            </div>
                        )
                    })}
                </Fragment>
            )
        }
    }

    triggerSearch = () => {
        let ic_list = this.getICList()
        this.setState({...this.state, 
            // results : [], 
            // class_results : [], 
            class_error : false, 
            searching : true, 
            search_error : false,
            ic_list_pushed : ic_list
        }, () => this.search())
    }

    search = () => {
        let { selected_ic } = this.state;
        let selected_ic_names = selected_ic.map((element) => {
            return element.name
        })

        console.log("CogSearch :: Searching : ", this.state.search_type)
        
        if (this.state.search_type === 'freetext') {
            Actions('http_request', {
                url : "/sainapse/recommendation/freetext/",
                method : 'post',
                data: {
                    ic_names : selected_ic_names,
                    search_query : this.state.search_string,
                    filters : this.state.filters
                }
            }).then(res => {
                this.setState({
                    ...this.state,
                    searching : false,
                    search_error : false,
                    results_received : true, 
                    results : res.data.result,
                    timestamp : res.data.timestamp,
                    result_container_height : this.state.open?this.screenHeight.current.clientHeight - this.searchBar.current.clientHeight:this.screenHeight.current.clientHeight
                }, () => console.log("Search Results :", this.state.results))
            }).catch(err => {
                this.setState({
                    ...this.state,
                    searching : false,
                    search_reco_error : true,
                    results_received : true, 
                    results : [],
                    timestamp : null,
                    result_container_height : this.state.open?this.screenHeight.current.clientHeight - this.searchBar.current.clientHeight:this.screenHeight.current.clientHeight
                })
            })
    
            Actions('http_request', {
                url : '/sainapse/classification/freetext/',
                method : 'post',
                data : {
                    ic_names : selected_ic_names,
                    search_query : this.state.search_string
                }
            }).then(res => {
                this.setState({
                    ...this.state,
                    class_received : true,
                    class_results : res.data.result,
                    class_error : false
                })
            }).catch(err => {
                this.setState({
                    ...this.state,
                    class_received : true,
                    class_results : [],
                    class_error : true
                })
            })
        }

        if (this.state.search_type === 'multifield') {
            let default_params = this.loadDefaultParams()

            let reco_search_options = default_params.icWVFieldMap.map(ic_map => {
                let ic_obj = {
                    ic_name : ic_map.ic_name,
                    search_options : []
                }
                let reco_config = ic_map.configs.find(config => config.operation === 'Recommend')
                console.log("CogSearch :: IC Name :", ic_map.ic_name)
                console.log("CogSearch :: Reco Config :", reco_config)

                if (reco_config) {
                    let search_fields = reco_config.fields.map(field => {
                        let search_option = {
                            field_name : field.name,
                            search_query : field.base.map(base => this.state.search_fields[base.name]).join(" ")
                        }
                        return search_option
                    })
    
                    ic_obj.search_options = search_fields
                }

                let filter = []
                let filter_index = this.state.filters.findIndex(filter => filter.ic_name === ic_map.ic_name)
                if (filter_index !== -1) {
                    filter = [this.state.filters[filter_index]]
                }

                ic_obj.filters = filter
                return ic_obj
            })

            Actions('http_request', {
                url : "/sainapse/recommendation/multifield/",
                method : 'post',
                data: reco_search_options
            }).then(res => {
                this.setState({
                    ...this.state, 
                    searching : false,
                    search_error : false,
                    results_received : true, 
                    results : res.data.result,
                    timestamp : res.data.timestamp,
                }, () => console.log("Search Results :", this.state.results))
            }).catch(err => {
                this.setState({
                    ...this.state,
                    searching : false,
                    search_reco_error : true,
                    results_received : true, 
                    results : [],
                    timestamp : null,
            })})

            let class_search_options = default_params.icWVFieldMap.map(ic_map => {
                let ic_obj = {
                    ic_name : ic_map.ic_name,
                    search_options : []
                }
                let class_config = ic_map.configs.find(config => config.operation === 'Classify')
                if (class_config) {
                    let search_fields = class_config.fields.map(field => {
                        let search_option = {
                            field_name : field.name,
                            search_query : field.base.map(base => this.state.search_fields[base.name]).join(" ")
                        }
                        return search_option
                    })
    
                    ic_obj.search_options = search_fields
                }
        
                let filter = []
                let filter_index = this.state.filters.findIndex(filter => filter.ic_name === ic_map.ic_name)
                if (filter_index !== -1) {
                    filter = [this.state.filters[filter_index]]
                }

                ic_obj.filters = filter
                return ic_obj
            })

            Actions('http_request', {
                url : '/sainapse/classification/multifield',
                method : 'post',
                data : class_search_options
            }).then(res => {
                this.setState({
                    ...this.state,
                    class_received : true,
                    class_results : res.data.result,
                    class_error : false
                })
            }).catch(err => {
                this.setState({
                    ...this.state,
                    class_received : true,
                    class_results : [],
                    class_error : true
                })
            })
        }
    }

    renderLogo = () => {
        return (
            <Fragment>
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '5px'}}>
                    <div style = {{flexGrow : 1}}>
                        <img style = {{height: '30px', margin: '5px'}} src = {logo} alt ='logo'/>
                    </div>
                    {/* {!this.state.open && <Button style = {{marginRight : '10px'}} color = 'primary' onClick = {() => this.setState({...this.state, open : true})}>Edit</Button>} */}
                </div>
                <Divider/>
            </Fragment>
        )
    }

    renderProgress = () => {
        if (this.state.searching === true) {
            return (
                <div style = {{width : '75vw', height : 'calc(100vh - 50px)', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent: 'center'}}>
                    <CircularProgress color = 'primary'/>
                </div>
            )
        }
    }

    renderSearchBar = () => {
        const { classes } = this.props

        if (this.state.open) {
            return (
                <Paper 
                    ref = {this.searchBar} 
                    style = {{
                        width : '25vw',
                        height : 'calc(100vh - 50px)',
                        oveflow: 'auto',
                        display : 'flex',
                        flexDirection : 'column'
                    }}
                    square 
                    elevation = {4}
                >
                    <div>
                        {this.renderLogo()}
                    </div>
                    <div style = {{flexGrow : 1, overflow: 'auto'}}>
                        {this.renderICSelect()}
                        <Divider/>
                        {this.renderSearchField()}
                    </div>
                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center' , width : '100%', padding: '10px', borderTop : '1px solid rgba(0,0,0,0.12)'}}>
                        {this.state.screen_cta_config && 
                            <div style = {{flexGrow : 1}}>
                                <CTAButton 
                                    cta_config={this.state.screen_cta_config} 
                                    record={null} 
                                    popper_width={'25vw'} 
                                    popper_height={'200px'}
                                    style_type = {'outlined'}
                                ></CTAButton>
                            </div>
                        }
                        <div style = {{flexGrow : 1, padding : '5px'}}>
                            <Button
                                variant='contained'
                                color ='primary'
                                size = 'small'
                                fullWidth
                                onClick={() => this.triggerSearch()}
                            >Search</Button>
                        </div>
                    </div>
                </Paper>
            )
        }
    }

    renderFloatingButton = () => {
        return (
            <Fab 
                style = {{
                    position : 'fixed',
                    top : 'calc(50vh - 25px)',
                    left : this.state.open ? 'calc(25vw - 25px)' : '-15px',
                    fontSize : 13,
                    zIndex : 10
                }}
                color = 'primary'
                variant="round"
                size = 'medium'
                onClick = {() => this.setState({...this.state, open : !this.state.open})}
                disabled = {false}
            >
                {this.state.open ? <ChevronLeft/> : <ChevronRight/>}
            </Fab>
        )
    }

    render() {
        const { classes } = this.props
        return (
            <Fragment>
                <ThemeProvider theme = {blue_theme}>
                    <div 
                        ref = {this.screenHeight}
                        style = {{
                            width : '100vw',
                            height : 'calc(100vh - 50px)',
                            display : 'flex',
                            flexDirection : 'row'
                        }}
                    >
                        {this.state.params_loaded && this.renderFloatingButton()}
                        {this.state.params_loaded && this.renderSearchBar()}
                        {/* {this.state.open ? this.renderSearchBar() : this.renderSearchBarForResults()} */}
                        {this.state.params_loaded && this.renderResults()}
                    </div>
                </ThemeProvider>
            </Fragment>
        );
    }
}

export default withStyles(styles)(CognitiveSearch);